import React from 'react';
function HeadingDivider(props) { return /*#__PURE__*/ React.createElement("h2", { className: "heading-divider" }, props.children); }
export default HeadingDivider;
